import type { ReactNode } from 'react';

import { QueryErrorDisplay } from './error-display/query-error-display';
import { Box } from './box';
import { Card } from './card';
import { CardContent } from './card-content';
import { PageHeader } from './page-header';

type PageWrapperProps = {
  children: ReactNode;
  error?: unknown;
  onRetry?: () => void;
  title?: string;
  description?: string;
  count?: number;
  countLabel?: string;
  useCard?: boolean;
};

export const PageWrapper = ({
  children,
  error,
  onRetry,
  title,
  description,
  count,
  countLabel,
  useCard = false
}: Readonly<PageWrapperProps>) => {
  if (error) {
    return (
      <Box p={3}>
        <QueryErrorDisplay error={error} onRetry={onRetry} />
      </Box>
    );
  }

  const content = (
    <>
      {title && (
        <PageHeader title={title} description={description} count={count} countLabel={countLabel} />
      )}
      {children}
    </>
  );

  if (useCard) {
    return (
      <Box p={3}>
        <Card>
          <CardContent>{content}</CardContent>
        </Card>
      </Box>
    );
  }

  return <Box p={3}>{content}</Box>;
};
